class PdpUpsellItemBundleBox extends HTMLElement {
  constructor() {
    super();
  }
  // Called when the element is connected to the document's DOM.
  connectedCallback() {
    this.section = this;

    this.bundleBoxesContainer = this.section.querySelector(
      "#bundle-boxes-container"
    );

    // Event listener for mouse click
    this.bundleBoxesContainer.addEventListener(
      "click",
      this.bundleBoxesEventHandler.bind(this)
    );

    // Event listener for keyboard interaction
    this.bundleBoxesContainer.addEventListener(
      "keydown",
      this.bundleBoxesKeydownHandler.bind(this)
    );
  }

  // Called when the element is disconnected from the document's DOM.
  disconnectedCallback() {
    this.bundleBoxesContainer.removeEventListener(
      "click",
      this.bundleBoxesEventHandler.bind(this)
    );

    this.bundleBoxesContainer.removeEventListener(
      "keydown",
      this.bundleBoxesKeydownHandler.bind(this)
    );
  }

  /**
   * Event handler for bundle box click events.
   * @param {Event} event - The event object.
   */
  bundleBoxesEventHandler(event) {
    const boxElement = event.target.closest(".bundle-box");
    if (!boxElement) return;
    this.deselectPreviousBox();
    const { bundleUpgradedSystem, bundleBoxHandle } = boxElement.dataset;
    boxElement.dataset.bundleBoxSelected = true;
    this.toggleBundleMessage(bundleUpgradedSystem);

    this.dispatchEvent(
      new CustomEvent("pdp-upsell-item-bundle-box-change", {
        bubbles: true,
        detail: {
          isBundleUpgradedSystem: bundleUpgradedSystem,
          bundleBoxHandle,
        },
      })
    );
  }

  /**
   * Event handler for bundle box keydown events.
   * @param {Event} event - The event object.
   */
  bundleBoxesKeydownHandler(event) {
    if (event.key === "Enter") {
      this.bundleBoxesEventHandler(event);
    }
  }

  // Deselects the previously selected bundle box.
  deselectPreviousBox() {
    const box = this.section.querySelector(
      `.bundle-box[data-bundle-box-selected="true"]`
    );
    if (box) {
      box.dataset.bundleBoxSelected = false;
    }
  }

  /**
   * Toggles the visibility of bundle messages based on the selected bundle.
   * @param {string} bundleUpgradedSystem - Indicates if the bundle is an upgraded system.
   */
  toggleBundleMessage(bundleUpgradedSystem) {
    const defaultBundleMessage = this.section.querySelector(
      "#default-bundle-message"
    );

    const upgradedBundleMessage = this.section.querySelector(
      "#upgraded-bundle-message"
    );

    defaultBundleMessage.dataset.showBundleMessage =
      bundleUpgradedSystem === "true" ? false : true;

    upgradedBundleMessage.dataset.showBundleMessage =
      bundleUpgradedSystem === "true" ? true : false;
  }

  /**
   * Gets the currently selected bundle box.
   * @returns {Object} An object containing the handle and upgrade status of the selected bundle box.
   */
  getSelectedBundleBox() {
    const box = this.section.querySelector(`[data-bundle-box-selected="true"]`);
    return {
      bundleBoxHandle: box.dataset.bundleBoxHandle,
      isBundleUpgradedSystem: box.dataset.bundleUpgradedSystem,
    };
  }

  // Resets the selected bundle box to the default state.
  resetValue() {
    this.deselectPreviousBox();
    const defaultBox = this.section.querySelector(
      `.bundle-box[data-bundle-upgraded-system="false"]`
    );

    defaultBox.dataset.bundleBoxSelected = true;
  }
}

customElements.define("pdp-upsell-item-bundle-box", PdpUpsellItemBundleBox);
